var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 21.121
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 330 \\u2013 4",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10297",
    d: "M9.924 20.061l-9.173-9.5 9.173-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M19.75 10.56h-19"
  }))));
}
export default SvgArrowLeft;